import { Grid } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { statusColors } from 'modules/orders/utils'
import {
  Table,
  TableProvider,
  ItemDetailDrawer,
  Card,
  Box,
  Tooltip,
  Chip
} from 'components'
import { formatCurrency } from 'utils'
import { Order } from 'modules/orders/types'

export const Items = ({ order }: { order?: Order }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState<any>({})

  const toggleDrawer = (open: boolean) => {
    setIsOpen(open)
  }

  const columns: GridColDef[] = [
    {
      field: 'productId',
      headerName: 'Código',
      width: 150,
      renderCell: (row) => {
        return (
          <Link
            style={{
              textDecoration: 'none',
              marginTop: -32,
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              justifyItems: 'center',
              color: '#0C95EB'
            }}
            to="#"
            onClick={() => {
              toggleDrawer(true)
              setSelectedItem(row?.row)
            }}
          >
            <Tooltip title={row?.row?.configurationDescription}>
              <div style={{ height: 16, fontWeight: 500 }}>
                {row?.row?.product?.id}
              </div>
            </Tooltip>
          </Link>
        )
      }
    },
    {
      field: 'name',
      headerName: 'Descrição',
      flex: 1,
      minWidth: 300,
      valueGetter: (params) => {
        return params.row.product.name
      }
    },
    {
      field: 'status',
      headerName: 'Situação',
      width: 200,
      renderCell: (row: any) => {
        if (row?.row?.status?.name) {
          return (
            <Chip
              sx={{
                fontSize: 12,
                width: '100%',
                ...statusColors[row?.row?.status?.id]
              }}
              label={row?.row?.status?.name}
            />
          )
        } else return `-`
      }
    },
    {
      field: 'quantityUn',
      headerName: 'Qtd Un.',
      minWidth: 70,
      renderCell: (row) => {
        return row?.value || ''
      }
    },
    {
      field: 'quantity',
      headerName: 'Qtd',
      minWidth: 70
    },
    {
      field: 'measure',
      headerName: 'Unidade',
      width: 100,
      valueGetter: (params) => {
        return params.row.product.unitMeasure
      }
    },

    {
      field: 'salePrice',
      headerName: 'Valor unitário',
      width: 155,
      type: 'number',
      renderCell: (row) => {
        return formatCurrency(row.value)
      }
    },
    {
      field: 'discountPercent',
      headerName: 'Desconto',
      type: 'number',
      renderCell: (row) => {
        return `${row.value}%`
      }
    },
    {
      field: 'total',
      headerName: 'Total',
      width: 160,
      type: 'number',
      renderCell: (row) => {
        return formatCurrency(row.row.salePrice * row.row.quantity)
      }
    }
  ]

  const totalWeight = order?.products.reduce(
    (acc, cur) => acc + +cur?.product?.weight * +cur?.quantity,
    0
  )
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 200px)'
      }}
    >
      <Card
        sx={{
          visibility: { xs: 'hidden', sm: 'visible', md: 'visible' },
          padding: {
            xs: 0,
            sm: '15px 15px 10px 15px',
            md: '15px 15px 10px 15px'
          },
          marginBottom: 1,
          maxWidth: 500,
          flexShrink: 0
        }}
      >
        <Box
          sx={{ visibility: { xs: 'visible', sm: 'visible', md: 'visible' } }}
        >
          <Grid container>
            <Grid item xs={12} sm={6}>
              <div
                style={{
                  fontSize: '0.79rem',
                  fontFamily: 'Montserrat',
                  fontWeight: 620
                }}
              >
                TOTAL DE MERCADORIA
              </div>
            </Grid>
            <Grid item xs={12} md={6} sx={{ marginTop: '-5px' }}>
              <div style={{ color: '#1AA053', fontWeight: 600 }}>
                {formatCurrency(
                  order?.products?.reduce(
                    (acc, cur) => acc + cur.salePrice * cur.quantity,
                    0
                  ) || 0
                )}
              </div>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} sm={6} mt={1}>
              <div
                style={{
                  fontSize: '0.79rem',
                  fontFamily: 'Montserrat',
                  fontWeight: 620
                }}
              >
                PESO TOTAL
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{ marginTop: { xs: 0, sm: 0, md: '4px' } }}
            >
              <div style={{ color: '#1AA053', fontWeight: 600 }}>
                {totalWeight?.toFixed(2)} kg
              </div>
            </Grid>
          </Grid>
        </Box>
      </Card>
      {/* <Grid container mb={2}>
        <Grid xs={12} sx={{ marginBottom: { xs: 2, md: 0 } }}>
          <Grid container>
            <Grid item xs={12} md={6}>
              <div
                style={{
                  fontSize: '0.79rem',
                  fontFamily: 'Montserrat',
                  fontWeight: 620
                }}
              >
                TOTAL DE MERCADORIA:
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div style={{ color: '#52C41A', fontWeight: 600 }}>
                {formatCurrency(
                  order?.data?.products?.reduce(
                    (acc, cur) => acc + cur.salePrice * cur.quantity,
                    0
                  ) || 0
                )}
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={12}>
          <Grid container>
            <Grid item xs={12} md={6}>
              <div
                style={{
                  fontSize: '0.79rem',
                  fontFamily: 'Montserrat',
                  fontWeight: 620
                }}
              >
                QUANTIDADE DE PRODUTO:
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div style={{ color: '#52C41A', fontWeight: 600 }}>
                {order?.data.products.reduce(
                  (acc, cur) => acc + cur.quantity,
                  0
                )}
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid> */}
      <div style={{ flex: 1, minHeight: 0 }}>
        <TableProvider>
          <Table
            columns={columns}
            getRowId={(row) => `${row.product.id}${row.sequence}`}
            rows={order?.products || []}
          ></Table>
        </TableProvider>
      </div>
      <ItemDetailDrawer
        item={selectedItem}
        open={isOpen}
        order={order}
        onClose={() => setIsOpen(false)}
      />
    </div>
  )
}
